export const getDateFromString = (str: string) => {
  const [
    year = '0',
    month = '1',
    day = '1',
    hours = '0',
    minutes = '0'
  ]: string[] = str.split(/[^0-9]/);

  return new Date(+year, +month - 1, +day, +hours, +minutes);
};
